import { useProductList } from "./useProductList";

/** Include inactive products so existing suppliers keep their normal landing page. */
export const useSupplierProductExistence = (enabled: boolean) =>
  useProductList(
    {
      limit: 1,
      sortBy: "name",
      sortDir: "asc",
      query: [
        { type: "ParentId", modifier: "IS_NULL" },
        { type: "type", modifier: "EQUALS", value: "product" },
        { type: "showAllProducts", modifier: "EQUALS", value: true },
      ],
    },
    { enabled },
  );
